import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPlayId: 1,
};

const videosSlice = createSlice({
  name: "videos",
  initialState,
  reducers: {
    addCurrentPlayId: (state, action) => {
      state.currentPlayId = action.payload;
    },
  },
});

export const { addCurrentPlayId } = videosSlice.actions;
export default videosSlice.reducer;
